// Centralised data-testid registry for the LO Portal frontend
export const TIDS = {
    // Layout
    appHeader: "app-header",
    bottomNav: "bottom-nav",
    navHome: "nav-home",
    navClasses: "nav-classes",
    navSearch: "nav-search",
    navBookmarks: "nav-bookmarks",
    navAnalytics: "nav-analytics",
    themeToggle: "theme-toggle",
    languageToggle: "language-toggle",

    // Landing
    heroTitle: "hero-title",
    heroSearchInput: "hero-search-input",
    heroSearchBtn: "hero-search-btn",
    heroExploreBtn: "hero-explore-btn",
    statTotalClasses: "stat-total-classes",
    statTotalSubjects: "stat-total-subjects",
    statTotalCodes: "stat-total-codes",

    // Classes
    classCard: (n) => `class-card-${n}`,
    subjectCard: (s) => `subject-card-${s.toLowerCase().replace(/\s+/g, "-")}`,

    // LO Card / Detail
    loCard: (code) => `lo-card-${code.replace(/\s+/g, "-")}`,
    loCopyBtn: (code) => `lo-copy-${code.replace(/\s+/g, "-")}`,
    loBookmarkBtn: (code) => `lo-bookmark-${code.replace(/\s+/g, "-")}`,
    loShareBtn: (code) => `lo-share-${code.replace(/\s+/g, "-")}`,
    loViewBtn: (code) => `lo-view-${code.replace(/\s+/g, "-")}`,
    loDetailCode: "lo-detail-code",
    loDetailDesc: "lo-detail-desc",
    loDetailRelated: "lo-detail-related",

    // Search
    searchInput: "search-input",
    searchVoiceBtn: "search-voice-btn",
    searchResults: "search-results",
    filterClass: "filter-class",
    filterSubject: "filter-subject",
    clearFilters: "clear-filters",

    // Admin
    adminUpload: "admin-upload",
    adminReseed: "admin-reseed",
    adminReplaceToggle: "admin-replace-toggle",

    // Export
    exportPdf: "export-pdf",
    exportCsv: "export-csv",
    exportExcel: "export-excel",
    exportJson: "export-json",
};
